import React, { useEffect, useState } from 'react';
import {
  Grid,
  Row,
  Column,
  Button,
  Divider,
  BUTTON_VARIANTS,
  IconChevronLeft,
  SimpleTableWrapper,
  SimpleTableBody,
  SimpleTableData,
  Input,
  ButtonLoader
} from 'cdk-radial';
import {
  FullWidthTableData,
  StickySimpleTable,
  StickySimpleTableContainer,
  StyledCenterDiv
} from '../../common/StyledComponents';
import ShippingDetailsTableHeaders from './ShippingDetailsTableHeaders';
import SearchableDropdown from '../../common/SearchableDropdown';
import { useToastProvider } from '../../providers/ToastProvider';
import { ZebraSimpleTableRow } from '../../common/styled';
import { useHistory } from 'react-router-dom';
import getEmptyForNull, {
    getInvalidOrders,
  transformOrders,
  validateOrders
} from '../../utils/utils';
import useUserInfo from '../../hooks/useUserInfo';
import submitOrderToDTNA from '../../adapters/services/submitOrderToDTNA';
import { useOktaAuth } from '@okta/okta-react';
import { URL_ROUTES } from '../../adapters/constants';
import { truncate } from 'lodash';
import GenericDialog from '../../common/GenericDialog';

export default function ShippingDetailsWrapper(props: any): JSX.Element {
  const { addErrorToast, addSuccessToast, addInformationToast } =
    useToastProvider();

  const history = useHistory();

  const { userInfo } = useUserInfo();

  const [isError, setIsError] = useState(false);

  const { authState } = useOktaAuth();

  const [loader, setLoader] = useState(false);
 
  

  const orderTypeData:any = props.dropDownData 
  .filter((item: any) => item.name === "OrderType")
  .map((item: any) => item.data)[0] || [];
 

  // dialog states
  const [isOpen, setIsOpen] = useState(false);

  const [dialogMessage, setDialogMessage] = useState("");

  const handleSubmitOrder = ()=>{
    window.dataLayer = window.dataLayer || [];
    const { transformedOrders, invalidParts } = transformOrders(
        props.selectedOrders
      );
      let reqPayload: any = transformedOrders;
      reqPayload['userData'] = {
        createdBy: userInfo?.iamUser?.username,
        enterpriseId: userInfo?.iamUser?.enterprise?.id,
        storeId: props.selectedGroup.groupName.storeId,
        dealerId: '', // this is not needed
        groupName: props.selectedGroup.groupName.value.split('-')[0]
      };
      submitOrderToDTNA(
        `Bearer ${getEmptyForNull(
          authState?.accessToken?.accessToken
        )}`,
        reqPayload
      )
        .then((data: any) => {
          setLoader(false);
          addSuccessToast(data.message);
          const messages = invalidParts.map(item => {
            const { orderNumber, invalidParts } = item;
            return `${orderNumber}(${truncate(
              invalidParts.join(', ')
            )})`;
          });

          if(invalidParts.length>0){
            addInformationToast('Invalid Parts: ' + messages);
          }
          // redirecting to home page
          handleNavigationClick();
          window.dataLayer.push({
            'event': 'Order Submitted'
          });
        })
        .catch((e: any) => {
          
          addErrorToast('Something went wrong!');
          // redirecting to home page
          handleNavigationClick();
          setLoader(false);
        });

      
  }

  const updateShippingPrefrences = (id: any, updatedObject: any) => {
    const updatedShippingCondition = props.dropDownData
    .find((item:any) => item.name === "ShippingPreference")
    .data.filter((item:any) => item.parentKey === updatedObject.DTNAOrderType.value);

    const updatedData = props.selectedOrders.map((item: any) =>
      item.orderNumber === id ? { ...item,...updatedObject , "shippingPreferences" : updatedShippingCondition,"shippingCond":{}} : item
    );
    props.setSelectedOrders(updatedData);
  };
  // Function to update a single object based on its id
  const updateObject = (id: any, updatedObject: any) => {
      
    const updatedData = props.selectedOrders.map((item: any) =>
      item.orderNumber === id ? { ...item, ...updatedObject } : item
    );
    props.setSelectedOrders(updatedData);
    if(updatedObject?.DTNAOrderType?.value){
      updateShippingPrefrences(id,updatedObject)
     }  
  };
  

  useEffect(() => {
    const isAllOrdersValid = validateOrders(props.selectedOrders);
    setIsError(isAllOrdersValid);
  }, [props.selectedOrders]);

  const handleNavigationClick = () => {
    history.push(URL_ROUTES.landingPage);
  };

  return (
    <Grid>
      <Row style={{ paddingLeft: '5px' }}>
        <h4 style={{ marginBottom: 0 }}>
          {
            'Provide Order & Shipping preferences, and transmit the order to OEM.'
          }
        </h4>
      </Row>

      {isError ? (
        <span
          style={{
            margin: 0,
            paddingLeft: '5px',
            color: '#E54B61',
            paddingBottom: '2px'
          }}
        >
          {'DTNA Order Type and Shipping Preference inputs are mandatory(*)'}
        </span>
      ) : (
        ''
      )}

      {
        isOpen ? <GenericDialog 
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            dialogActions={
                {
                    id: 'dialog-step-3-action-1',
                    onClick: handleSubmitOrder,
                    text: 'Yes',
                    variant: BUTTON_VARIANTS.PRIMARY
                }
            }
            dialogMessage={dialogMessage}
            setLoader={setLoader}
        /> : ""
      }
      <Row>
        <SimpleTableWrapper
          style={{
            width: '100%',
            marginTop: "8px"
          }}
        >
          <StickySimpleTableContainer style={{ height: '536px' }}>
            <StickySimpleTable aria-label="Table-shipping-details">
              <ShippingDetailsTableHeaders />
              <SimpleTableBody>
                {props.selectedOrders.length === 0 ? (
                  <FullWidthTableData colSpan={15}>
                    <StyledCenterDiv>
                      No order to show.
                    </StyledCenterDiv>
                  </FullWidthTableData>
                ) : (
                  props.selectedOrders.map((order: any, index: number) => {
                    return (
                      <ZebraSimpleTableRow key={index + 'shipping'}>
                        <SimpleTableData colSpan={2} textAlign="left">
                          {order?.orderNumber}
                        </SimpleTableData>
                        <SimpleTableData colSpan={3}>
                          <Input
                            dataTestId="input-shipping-details"
                            // errorMessage="Error message"
                            hideBorder="none"
                            // iconPosition="trailing"
                            id="manual-PO-input"
                            inputDivider="left"
                            // label="Manual PO Number"
                            name="manual-po-number"
                            onChange={(event: any) => {
                              updateObject(order.orderNumber, {
                                customerPO: event.target.value
                              });
                            }}
                            // placeholder="For eg. 1234"
                            size="small"
                            value={order.customerPO}
                            isRequired={false}
                            maxLength={15}
                            // onInputClear={()=>{
                            //     updateObject(order.orderNumber, {customerPO: ""});
                            // }}
                            // hasClearButton={true}
                          />
                        </SimpleTableData>
                        <SimpleTableData colSpan={3}>
                          <SearchableDropdown
                            id={`input-dtna-order-type-${index}`}
                            key={`orderType-${index}-${order.orderNumber}`}
                            label=""
                            defaultOptions={orderTypeData}
                            setSelectedOption={(option: any) => {
                              updateObject(order.orderNumber, {
                                DTNAOrderType: option
                              }
                            );                             
                            }}
                            selectedOption={order.DTNAOrderType}
                            isRequired={true}
                            isDisabled={false}
                            placeHolder={' '}
                            // hasClearButton={true}
                            size="small"
                          />
                        </SimpleTableData>
                        <SimpleTableData colSpan={3}>
                          <SearchableDropdown
                            id={`input-shipping-preferences-${index}}`}
                            key={`shipPref-${index}-${order.orderNumber}`}
                            label=""
                            defaultOptions={order.shippingPreferences || []}
                            setSelectedOption={(option: any) => {
                              updateObject(order.orderNumber, {
                                shippingCond: option
                              });
                            }}
                            selectedOption={order.shippingCond}
                            isRequired={true}
                            isDisabled={false}
                            placeHolder={'Search Shipping Preference'}
                            // hasClearButton={true}
                            size="small"
                          />
                        </SimpleTableData>
                        <SimpleTableData colSpan={4}>
                          <Input
                            dataTestId="input-shipping-notes"
                            // errorMessage="Error message"
                            hideBorder="none"
                            id="shipping-notes-input"
                            inputDivider="left"
                            name="shipping-notes-input"
                            onChange={(event: any) => {
                              updateObject(order.orderNumber, {
                                orderRefText: event.target.value
                              });
                            }}
                            // placeholder="For eg. 1234"
                            size="small"
                            value={order.orderRefText}
                            maxLength={35}
                            hasClearButton={true}
                            onInputClear={() => {
                              updateObject(order.orderNumber, {
                                orderRefText: ''
                              });
                            }}
                          />
                        </SimpleTableData>
                      </ZebraSimpleTableRow>
                    );
                  })
                )}
              </SimpleTableBody>
            </StickySimpleTable>
          </StickySimpleTableContainer>
        </SimpleTableWrapper>
      </Row>
      <Divider style={{opacity:"70%"}}></Divider>
      <Grid>
        <Row>
          <Column l={8} m={12} s={12} xl={8} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                iconColor="primary"
                style={{ backgroundColor: '#E8F1FC' }}
                data-testid="stepper-back-button"
                text="Previous"
                icon={<IconChevronLeft />}
                onClick={() => props.setActiveState(props.activeState - 1)}
                variant={BUTTON_VARIANTS.TEXT}
              />
            </div>
          </Column>
          <Column l={4} m={12} s={12} xl={4} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                iconColor="primary"
                data-testid="stepper-next-button"
                text={'Transmit Order'}
                onClick={() => {
                  setLoader(true);                 
                  let validationValue: any = getInvalidOrders(props.selectedOrders);                
                  if(validationValue.length > 0){
                    setIsOpen(true);
                    setDialogMessage("VDI flags will be removed for Order types - ZFSO, ZFDS "+ `(${validationValue.join(",")})`)
                    return;
                  }else{
                    handleSubmitOrder();
                  }
                }}
                isDisabled={props.selectedOrders.length === 0 ? true : isError}
                icon={
                  loader ? (
                    <ButtonLoader />
                  ) : (
                    <div
                      style={{ marginRight: '4px', height: 0, width: 0 }}
                    ></div>
                  )
                }
                isIconTrailing={true}
              />
            </div>
          </Column>
        </Row>
      </Grid>
    </Grid>
  );
}
